// Barcode constants - shared between recipe labels (jQuery UI) and supplement labels (Vue)
// Separated from barcode.js to avoid jQuery dependency when only constants are needed

const CODE_128 = "code128";
const EAN_13 = "ean13";
const UPC_A = "upc_a";
const DEFAULT_BARCODE_TYPE = CODE_128;

const MIN_HEIGHT = 20;
const MAX_HEIGHT = 150;
const HEIGHT_STEP = 5;
const MIN_WIDTH = 1;
const MAX_WIDTH = 5;
const WIDTH_STEP = 1;
const DEFAULT_BARCODE_WIDTH = 2;
const DEFAULT_BARCODE_HEIGHT = 50;

export const BARCODE_CONSTANTS = {
  CODE_128,
  EAN_13,
  UPC_A,
  DEFAULT_TYPE: DEFAULT_BARCODE_TYPE,
  DEFAULT_WIDTH: DEFAULT_BARCODE_WIDTH,
  DEFAULT_HEIGHT: DEFAULT_BARCODE_HEIGHT,
  MIN_HEIGHT,
  MAX_HEIGHT,
  HEIGHT_STEP,
  MIN_WIDTH,
  MAX_WIDTH,
  WIDTH_STEP,
};

// Map backend barcode type to JsBarcode format
export function getBarcodeFormat(type) {
  if (type === UPC_A) return "UPC";
  if (type === EAN_13) return "EAN13";
  return "CODE128";
}
